import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import moment from 'moment';
import Pagination from './../../../../shared/components/pagination';
import Report from '../../../services/report.service';
import Util from '../../../../shared/util/util';
import Loader from './../../../../shared/components/loader';
import XLSX from 'xlsx';
import DatePicker from 'vue2-datepicker';
import Treeselect from '@riophae/vue-treeselect';
export default {
  name: 'partblog',
  components: {
    Pagination,
    VueElementLoading,
    Loader,
	  DatePicker,
	  Treeselect,
  },
  props: [],
  data() {
    return {
      isLoading: false,
      PartBFromDate: null,
      PartBToDate: null,
      TotalDataPartB: [],
      totalCountPartB: 0,
      totalPagePartB: 0,
      currentPartBPage: 1,
      selectedpartbdate: null,
      selectedpartbFromDate: '',
      partBTrack:false,
      EWBnumber:'',
      PartBToDateErr:"",
      PartBFromDateErr:"",
      selectedpincodedate:"",
      validDateRange2partb:"",
      showEWB:false,
      statusList:[
        {id:'0',label:'Failed'},
        {id:'1',label:'Success'},
      ],
      status:null,
      minfromdate: '',
      todaysDate2: '',
      modalData:'',
      offset:0,
      pageLimit:10,
    }
  },
  computed: {
  },
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment.utc(date).format('DD-MM-YYYY HH:mm:ss');
    },
  },
  async mounted() {
      var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
      var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
      var plaintext = bytes.toString(CryptoJS.enc.Utf8);
      var userdetail = JSON.parse(plaintext);
      this.todaysDate1 = moment().format('YYYY-MM-DD');
      this.todaysDate2 = moment().format('YYYY-MM-DD');
      await this.partbsearchFilter();
      this.mindateforPartB();
  },
  methods: {
    isIntegerOnlty: function(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode < 48 || charCode > 57) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    mindateforPartB() {
      var dtToday = new Date();
      var month = dtToday.getMonth();
      var day = dtToday.getDate();
      var TOday = dtToday.getDate();
      var year = dtToday.getFullYear();
      if (month < 10)
      month = '0' + month.toString();
      if (day < 10)
      day = '0' + day.toString();
      this.minfromdate = year + '-' + month + '-' + day;
    },
    onPageChangeUpdatePartB(page) {
      this.currentPartBPage = page;
      this.offset = (page - 1) * this.pageLimit
      this.getupdatepartbummarydata();
    },
    partbsearchFilter() {
      this.currentPartBPage = 1;
      this.partBTrack = true;
      this.offset = 0;
      this.getupdatepartbummarydata();
    },
    partbresetSearch() {
      this.partBTrack = false,
      this.currentPartBPage = 1;
      this.PartBFromDate = null;
      this.PartBToDate = null;
      this.EWBnumber = null;
      this.companyName = null;
      this.getupdatepartbummarydata();
      this.PartBFromDateErr = '';
      this.PartBToDateErr = '';
      this.status=null
    },
    checkpartBErr() {
      let err = 0
      if ((this.PartBFromDate != null && this.PartBFromDate != "") && (this.PartBToDate != null && this.PartBToDate != "")) {
        this.PartBFromDateErr = ""
        this.PartBToDateErr = ""
        err = 0
      }
      else {
        if (this.PartBFromDate != null && this.PartBFromDate != "") {
          this.PartBToDateErr = "Please Select To Date"
          this.PartBFromDateErr = ""
          err = 1
        }
        else if (this.PartBToDate != null && this.PartBToDate != "") {
          this.PartBFromDateErr = "Please Select From Date"
          this.PartBToDateErr = ""
          err = 1
        }
        else {
          this.PartBFromDateErr = ""
          this.PartBToDateErr = ""
        }
      }
      return err
    },
    displayEWB(data) {
      this.modalData = data.ebn.join(", ");
      this.showEWB = true
    },
    async getupdatepartbummarydata(flag) {
      try {
        if (this.checkpartBErr() == 1) {
          return false
        }
        this.isLoading = true;
        let inputPayload = {
        "offset": this.offset,
        "limit": this.pageLimit,
        }
        if (flag == 1) {
          inputPayload.limit = 30;
        }
        if (this.PartBFromDate != null && this.PartBFromDate != "") {
          inputPayload.createddatefrom = (this.PartBFromDate);
        }
        if (this.PartBToDate != null && this.PartBToDate != "" ) {
          inputPayload.createddateto = (this.PartBToDate);
        }
        if (this.EWBnumber) {
          inputPayload.ewb = this.EWBnumber.trim();
        }
        if (this.status) {
          inputPayload.status = this.status;
        }
        let result = await Report.getupdatepartblogs(inputPayload)
        if (result.data.code == 200 && result.data.data != null) {
          this.totalCountPartB = result.data.data.count;
          this.TotalDataPartB = result.data.data.data;
        }
        else {
          this.totalCountPartB = 0;
        }
        if (this.totalCountPartB < this.pageLimit) {
          this.totalPagePartB = 1
        } else {
          this.totalPagePartB = Math.ceil(this.totalCountPartB / this.pageLimit);
        }
        this.isLoading = false;
        return result;
      }
      catch (err) {
        this.isLoading = false;
      }
    },
    async exportPartBData() {
      try {
        let inputPayload = {
        "offset": 0,
        "limit": this.totalCountPartB,
        }
        if (this.PartBFromDate != null&& this.PartBFromDate != "") {
          inputPayload.createddatefrom = (this.PartBFromDate);
        }
        if (this.PartBToDate != null && this.PartBToDate != "") {
          inputPayload.createddateto = (this.PartBToDate);
        }
        if (this.EWBnumber) {
          inputPayload.ewb = this.EWBnumber;
        }
        if (this.status) {
          inputPayload.status = this.status;
        }
        let data = await Report.getupdatepartblogs(inputPayload)
        this.isLoading = true;
        if (data && data.data.code == 200) {
          var tempdata = [];
          var temp = data.data.data.data;
          if (temp.length > 0) {
            temp.forEach(el => {
              tempdata.push({
                'EWB Number': el.ebn.join(', '),
                'Vehicle Number': el.vehicleNo,
                'From Place': el.fromPlace,
                'From State': el.fromState,
                'Vehicle Update Reason': el.vehicleUpdateReason,
                'Requested By': el.requestedBy,
                'Transport Mode': el.transportMode,
                'Created Date': el.createddate,
                'Status': el.status,
              });
            });
          }
          else {
            this.$alert(data.data.message, "", "error");
          }
          let dt = moment().tz('Asia/Kolkata').format('YYYYMMDDHHmmss');
          const data1 = XLSX.utils.json_to_sheet(tempdata);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, data1, 'data')
          XLSX.writeFile(wb, dt + '_PartBLog.xlsx');
        }
        else {
        this.$alert(data.data.message, "", "error");
        this.$alert("No Part B records to download", "Error", "error");
        }
        this.isLoading = false;
      } catch (err) {
        this.isLoading = false;
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/modules/report/views/PrintingLog/partblog/partblog.component.js